import React from 'react';
import { motion } from 'framer-motion';
import ProjectStatsBadge from '../../../components/ProjectStatsBadge';
import ShareProjectButton from '../../../components/ShareProjectButton/ShareProjectButton';
import './smart-expense.css';
import smartExpenseImg from '../../../assets/images/SmartExpense Photo.png';


const SmartExpense = () => {
  return (
    <motion.div 
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1 
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        SmartExpense <span>Enterprise</span> – AI-Powered Financial Management System 💳💼
      </motion.h1>

      <motion.p 
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      ><br />
        Last Updated On: 02 August 2026
      </motion.p>

      <div className="project-content">
        <motion.div 
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img src={smartExpenseImg} alt="SmartExpense Dashboard" className="project-image" />
          <h2 className="project-subtitle">SmartExpense SaaS</h2>
          <span className="project-category">Software Applications</span>
          <p className="project-author">Author: Praveen Kumar B</p>

          <ProjectStatsBadge docId="smartExpense" trackView={true} />

          <div className="project-buttons">
            <a
              href="https://smart-expense-web.vercel.app/"
              className="visit-project-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              → Visit the Project
            </a>
            <a
              href="https://github.com/Praveenkumar-king"
              className="visit-project-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              → View on GitHub
            </a>
            <ShareProjectButton
              project={{
                id: "smartExpense",
                title: "SmartExpense",
                path: "/projects/projectdetail/smart-expense"
              }}
            />
          </div>
        </motion.div>

        <motion.div 
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">Overview ✨</h3>
          <p className="overview-description">
            <strong>SmartExpense</strong> is a modern, enterprise-grade AI-powered financial management system built on SaaS architecture. 
            Designed to deliver real-time financial performance and smart insights, it empowers individual users and businesses to track <strong>Income, Expenditures, Cash Flow, and Savings Goals</strong> with complete precision and high-level security. 📊💼
          </p>

          <h3 className="section-title">Key Modules & Features 🛠️</h3>
          <ul className="feature-list">
            <li>Financial Dashboard 📊 – Real-time tracking of Total Income, Expenditures, Net Cash Flow, and Savings Rates.</li>
            <li>Automated Health Score 🛡️ – AI-driven evaluation system rating financial stability (0-100 scale).</li>
            <li>Cash Flow Analytics 📈 – Visual ratio comparisons between monthly earnings and spending patterns.</li>
            <li>Income & Expense Tracker 💸 – Fast tracking tools with seamless Quick Add modal workflows.</li>
            <li>Category Breakdown 🍰 – Interactive distribution maps for categorized expenditure analysis.</li>
            <li>Budget Management 🎯 – Custom budget allocation with threshold limits and warnings.</li>
            <li>Savings Goals Tracker 💰 – Dedicated goal mapping to track financial targets step-by-step.</li>
            <li>Smart Insights Engine 💡 – Real-time automated spending insights and optimization recommendations.</li>
            <li>Reports & Analytics 📑 – Comprehensive downloadable financial statement summaries.</li>
            <li>Support & Ticketing System 🎟️ – Built-in support portal for enterprise user assistance.</li>
          </ul>

          <h3 className="section-title">Advanced Architecture & AI Features 🚀</h3>
          <ul className="feature-list">
            <li>🤖 Automated AI Financial Assessment & Health Score Algorithm</li>
            <li>🔍 Global Search across all transactions, budgets, and accounts</li>
            <li>🔒 Enterprise-level JWT Authentication with session management</li>
            <li>📈 Dynamic charts for Cash Flow Ratio Comparison</li>
            <li>🌙 Built-in Dark Mode Enterprise UI with sleek glassmorphic themes</li>
            <li>🎟️ Help Desk with integrated Support Ticket tracking</li>
          </ul>

          <h3 className="section-title">Why SmartExpense? 🤔</h3>
          <ul className="how-it-works-list">
            <li>💼 Enterprise SaaS Architecture with scalable database design</li>
            <li>⚡ Lightning-fast performance with real-time UI synchronization</li>
            <li>🔐 Secure token-based session handling and data privacy</li>
            <li>📊 Complete 360° visibility over cash flow and financial health</li>
          </ul>

          <h3 className="section-title">Conclusion 🎯</h3>
          <p>
            <strong>SmartExpense Enterprise</strong> is more than just an expense tracker — it's a full-featured Financial SaaS platform. 
            It demonstrates advanced full-stack engineering skills, complex dynamic analytics, and enterprise UX design standards built to scale. 🚀🔥
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default SmartExpense;